@if (view$ | async; as view) {
    <div [formGroup]="view.formGroup">
        <div class="row">
            <div class="col-6">
                <app-input-text-group
                    [label]="
                        ('reporting_GROUP_NAME' | translate) + (view.compareGroups ? ' 1' : '')
                    "
                    [formControl]="view.formGroup.controls.groupName" />

                @if (view.compareGroups) {
                    <app-input-text-group
                        [label]="('reporting_GROUP_NAME' | translate) + '  2'"
                        [formControl]="view.formGroup.controls.groupName2" />
                }

                <app-input-select-option-group
                    [data]="view.superTypeTranslationMap"
                    [label]="'utilities_SELECT_METER_TYPE' | translate"
                    [formControl]="view.formGroup.controls.meterSuperTypeNo" />
            </div>

            <div class="col-6">
                @if (view.formGroup.value.meterSuperTypeNo) {
                    <app-input-select-option-group
                        [data]="view.outputUnitsData"
                        [label]="'utilities_output_unit' | translate"
                        [formControl]="view.formGroup.controls.outputUnit" />

                    <app-input-checkboxes
                        [required]="true"
                        [label]="'utilities_Select_meter_usage_and_unit' | translate"
                        [formControl]="view.formGroup.controls.selectableUsageAndUnits" />
                }
            </div>
        </div>
    </div>
}
